module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-03-bg.c533831e.jpg";